import { APP_ID } from '@glass/web/modules/content/pages/contentIds';

import tracking from '@glass/shared/modules/tracking';

export default tracking.createChild({ context: APP_ID });
